import { Row, Col } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowDimensions } from '../../../../hooks/useWindowDimensions';
import { SMALL_DEVICE_WIDTH } from '../../../../utils/constants/constants';
import { DATE_FORMAT, TIME_FORMAT_SHORT } from '../../../../utils/constants/domain-constants';
import rlDriver from '../../../../assests/img/rl-driver.svg';
import rlChevronDown from '../../../../assests/img/rl-chevron-down.svg';
import rlChevronUp from '../../../../assests/img/rl-chevron-up.svg';
import TryDispatcher from '../../../../components/TryDispatcher/TryDispatcher';

interface Props {
    routeEta?: string;
    driverName?: string;
    remainingDistance?: number;
    address?: string;
    isPromoVisible: boolean;
    onTryDispatcherButton: () => void;
}

const DriverEtaShareInfo = (props: Props) => {
    const { t } = useTranslation();
    const { width } = useWindowDimensions();
    const [infoVisible, setInfoVisible] = useState(true);

    const remainingTime = props.routeEta && moment(props.routeEta).diff(moment());
    const remainingTimeDurationFormat =
        remainingTime && remainingTime > 0
            ? `${moment.duration(remainingTime).days() ? moment.duration(remainingTime).days() + 'd' : ''} ${
                  moment.duration(remainingTime).hours() ? moment.duration(remainingTime).hours() + 'h' : ''
              } ${moment.duration(remainingTime).minutes() ? moment.duration(remainingTime).minutes() + 'm' : ''}`
            : 0;

    useEffect(() => {
        setInfoVisible(width > SMALL_DEVICE_WIDTH);
    }, [width]);

    return (
        <div className="driver-eta-share-info-wrapper" style={{ width: props.isPromoVisible ? width / 2 : '100%' }}>
            <div className="driver-eta-share-info">
                <div className="driver-eta-share-info-content">
                    {infoVisible && (
                        <Row style={{ paddingBottom: '16px' }} align={'middle'}>
                            <Col>
                                <img src={rlDriver} height={35} alt="Driver" style={{ paddingRight: '8px' }} />
                            </Col>
                            <Col>
                                <span className="driver-eta-share-info-content-driver">
                                    <b>{props.driverName}</b> {t('DriverEtaShareInfo.isSharing')}
                                </span>
                            </Col>
                            {width <= SMALL_DEVICE_WIDTH && (
                                <Col
                                    flex={'auto'}
                                    className="driver-eta-share-info-visible"
                                    onClick={() => setInfoVisible(!infoVisible)}
                                >
                                    <img src={rlChevronDown} height={35} alt="Hide" />
                                </Col>
                            )}
                        </Row>
                    )}
                    <Row>
                        {infoVisible && (
                            <Col span={24} lg={12}>
                                <b>{t('DriverEtaShareInfo.destination')}</b>
                                <p className="driver-eta-share-info-content-address">
                                    {props.address || 'Via IV Novembre, 14, 20085'}
                                </p>
                            </Col>
                        )}
                        <Col span={10} lg={6}>
                            <b className="driver-eta-share-info-content-time">
                                {moment(props.routeEta).format(TIME_FORMAT_SHORT)}
                            </b>
                            (
                            <span className="driver-eta-share-info-content-date">
                                {moment(props.routeEta).format(DATE_FORMAT)})
                            </span>
                            <p className="driver-eta-share-info-content-arrival">{t('DriverEtaShareInfo.arrival')}</p>
                        </Col>
                        <Col span={4} lg={2}>
                            <b className="driver-eta-share-info-content-distance">
                                {props.remainingDistance ? (props.remainingDistance / 1000).toFixed(0) : 0}
                            </b>
                            <p className="driver-eta-share-info-content-km">{t('DriverEtaShareInfo.km')}</p>
                        </Col>
                        <Col span={8} lg={4}>
                            <b className="driver-eta-share-info-content-duration">{remainingTimeDurationFormat}</b>
                            <p className="driver-eta-share-info-content-timeleft">{t('DriverEtaShareInfo.timeLeft')}</p>
                        </Col>
                        {!infoVisible && (
                            <Col span={2} className="driver-eta-share-info-visible">
                                <img
                                    src={rlChevronUp}
                                    height={35}
                                    alt="Hide"
                                    onClick={() => setInfoVisible(!infoVisible)}
                                />
                            </Col>
                        )}
                    </Row>
                </div>
                <TryDispatcher onTryDispatcherButton={props.onTryDispatcherButton} color={'#f1f4f9'} />
            </div>
        </div>
    );
};

export default DriverEtaShareInfo;
